import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT, VIEW, YES } from "const"
import {
    StoreType,
    setRrsCategoryBaseRoute,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    rrsCategoriesRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import List from "./list"
import Edit from "./edit"

const RrsCategory = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const { rrsRiskSpaceModuleAccess } = packageSettings
    const access = userData.accountId === 1 || rrsRiskSpaceModuleAccess === YES

    const baseRouteMask = project.id ? `${projectBaseRoute}${rrsCategoriesRoute}` : rrsCategoriesRoute
    const baseRoute = project.id ? `${projectsRoute}/${VIEW}/${project.id}${rrsCategoriesRoute}` : rrsCategoriesRoute

    useEffect(() => {
        dispatch(setRrsCategoryBaseRoute(baseRoute))
    }, [])

    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${EDIT}/:categoryId`}
                component={Edit}
            />
            <Route
                path={baseRouteMask}
                component={List}
            />
        </Switch>
    )
}
export default RrsCategory
